import React from 'react';
import {Link} from "react-router-dom";
import {HashLink} from "react-router-hash-link";

function Nav() {

    return (
        <nav className="navbar navbar-expand-md navbar-light static-top bg-light">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault"
                    aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarsExampleDefault">
                <ul className="navbar-nav mr-auto">
                    <li className="nav-item">
                        <Link className="nav-link" to="/">About</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/blog/">Blog<span
                            className="sr-only">Blog</span></Link>
                    </li>
                    <li className="nav-item">
                        <HashLink className="nav-link" to="/#contact">Contact</HashLink>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Nav;